import { Box, ColorOptions } from '@jfs/ui-new'
import { isIE } from '@jfs/ui-new/src/utils/utils'
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs'
import { NavigationContainer, NavigationIndependentTree } from '@react-navigation/native'
import { FC, useState } from 'react'
import { Modal } from '../../comps/Modal'
import { ModalHeader } from '../../comps/ModalHeader'
import { useStores } from '../../data/store'
import { EMI, EMI as EMIPaymentType } from '../../utils/constants'
import { EMIPlans } from './EMIPlans'
import { TabBar } from './TabBar'

const CCAllEMIPlans: FC<{ open: boolean; setOpen: () => void }> = ({
  open,
  setOpen,
}: {
  open: boolean
  setOpen: (open: boolean) => void
}) => {
  const { theme } = useStores((root) => ({
    theme: root.config.merchantTheme,
  }))

  const [show, setShow] = useState(open)

  const Tab = createMaterialTopTabNavigator()

  const onDismiss = () => {
    setShow(false)
    setOpen(false)
  }

  const modalBodyView = () => {
    return (
      <NavigationIndependentTree>
        <NavigationContainer>
          <Tab.Navigator
            screenOptions={{ sceneStyle: { backgroundColor: theme.bodyBgColor } }}
            tabBar={(props) => <TabBar {...props} theme={theme} />}>
            <>
              <Tab.Screen name="No Cost EMI" component={NoCostCCEMIPlans} />
              <Tab.Screen name="Standard EMI's" component={StandardEMIPlans} />
            </>
          </Tab.Navigator>
        </NavigationContainer>
      </NavigationIndependentTree>
    )
  }

  return (
    <Modal
      type={'BottomTop'}
      headerType="White_Bg"
      show={show}
      onDismiss={onDismiss}
      isFullWidth={true}
      theme={theme}
      containerTopPadding={isIE() ? 5 : undefined}>
      <Box borderTopLeftRadius={16} borderTopRightRadius={16} backgroundColor={theme.bodyBgColor as ColorOptions} f={1}>
        <ModalHeader title="EMI Plan" onDismiss={onDismiss} theme={theme} />
        {modalBodyView()}
      </Box>
    </Modal>
  )
}

export const StandardEMIPlans = () => {
  const { getEMIPlans } = useStores((root) => ({
    getEMIPlans: root.getEMIPlans,
  }))

  return <EMIPlans plans={getEMIPlans(EMIPaymentType.CREDIT_CARD_ALL)} />
}

export const NoCostCCEMIPlans = () => {
  const { getEMIPlans } = useStores((root) => ({
    getEMIPlans: root.getEMIPlans,
  }))

  return <EMIPlans plans={getEMIPlans(EMI.NO_LOW_COST_CC_ALL)} />
}

export interface EMIDetailsModal {
  shouldShow: boolean
  data: any
}

export { CCAllEMIPlans }
